<ng-template let-item>
  <ng-container *ngIf="item.tag">
    {{ item.tag }}
  </ng-container>
  <ng-container *ngIf="item.actionType">
    <span class="d-flex flex-gap-3 justify-content-between w-100 align-items-end">
      <span
        *ngIf="isSpaceAction(item.actionType)"
        class="ico ico-space-bar"></span>
      <span *ngIf="!isSpaceAction(item.actionType)">,</span>
      <span class="text-xs">{{ actionFormatter(item.actionType) }}</span>
    </span>
  </ng-container>
  <ng-container *ngIf="!item.tag && !item.actionType">
    <span
      *ngIf="item.icon"
      class="mr-2"
      [ngClass]="item.icon"></span>
    {{ itemFormatter(item) }}
  </ng-container>
</ng-template>
